<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('fertilization.fertilizer_application_info') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-md-4">
        <label>{{ $t('common_words.date') }} *</label>
        <el-date-picker
          v-if="renderComponent"
          v-model="model.date"
          class="date-ced"
          type="date"
          :placeholder="$t('common_words.year_selection')"
          @change="getBudgetedCard"
        >
        </el-date-picker>
      </div>
      <div class="col-md-4">
        <label>{{ $t('fertilization.fertilizing_type') }} *</label>
        <br />
        <el-select
          clearable
          :disabled="disabled"
          filterable
          class="select-primary custom-width-select required shadow-sm fer-type"
          size="large"
          v-model="model.type"
          @change="getFarm"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            class="select-primary"
            value="Finca"
            :label="$t('common_words.farm')"
          ></el-option>
          <el-option
            class="select-primary"
            value="Lote"
            :label="$t('common_words.allotment')"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-4">
        <label>{{ $t('common_words.farm') }} *</label>
        <br />
        <el-select
          clearable
          :disabled="disabledFarm"
          filterable
          class="select-primary custom-width-select required shadow-sm farm-fer"
          size="large"
          v-model="model.farm_id"
          @change="getLots"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="(option, index) in farms"
            class="select-primary"
            :value="option.id"
            :label="option.name"
            :key="index + option.id"
          ></el-option>
        </el-select>
      </div>
      <div class="col-md-4" v-if="model.type == 'Lote'">
        <label>{{ $t('common_words.allotment') }} *</label>
        <br />
        <el-select
          clearable
          filterable
          class="select-primary custom-width-select required shadow-sm lot-fer"
          size="large"
          v-model="model.lot_id"
          :placeholder="`${$t('common_words.select')}...`"
        >
          <el-option
            v-for="(option, index) in lots"
            class="select-primary"
            :value="option.id"
            :label="option.name"
            :key="index + option.id"
          ></el-option>
        </el-select>
      </div>
      <div class="col-md-4">
        <fg-input
          type="number"
          :label="`${$t('production.hectares')} *`"
          min="0"
          @change="fillHectares"
          v-model="model.hectares"
          v-validate="modelValidations.hectares"
          name="production.hectares"
          :error="getError('production.hectares', true)"
        >
        </fg-input>
      </div>
    </div>
    <div class="row" v-show="errorAlert">
      <div class="col-lg-12">
        <br />
        <el-alert
          ref="error_alert"
          :title="$t('common_words.errors')"
          type="error"
          >{{ error }}</el-alert
        >
      </div>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      model: {
        date: null,
        area: null,
        hectares: null,
        type: null,
        farm_id: null,
        lot_id: null,
        boxes_per_hectare: null,
        trm: null,
      },
      modelValidations: {
        hectares: {
          required: true,
        },
      },
      farms: [],
      lots: [],
      disabled: false,
      disabledFarm: false,
    };
  },

  mixins: [mixinMasters, MixinForm, MixinPermissions],

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          let others = [];
          this.$emit('fillFertilizationApplicationForm', 'firstStep', {
            names_business: others,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (this.model.date == null) {
            this.highlightItem('date-ced');
            return false;
          } else if (this.model.type == null) {
            this.highlightItem('fer-type');
            return false;
          } else if (this.model.farm_id == null) {
            this.highlightItem('farm-fer');
            return false;
          } else if (this.model.type == 'Lote' && this.model.lot_id == null) {
            this.highlightItem('lot-fer');
            return false;
          } else {
            return true;
          }
        });
    },

    fillHectares() {
      localStorage.setItem('hectares', this.model.hectares);
    },

    getFarm() {
      this.showHideLoading(true);

      Axios.getMasters('farms/farms/only')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    getLots() {
      this.showHideLoading(true);

      Axios.getMasters('lots/' + this.model.farm_id)
        .then((response) => {
          this.lots = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    getBudgetedCard() {
      if (this.model.date) {
        let year = this.model.date.getFullYear();

        Axios.getMasters('fertilization/budgeted_cards/' + year)
          .then((response) => {
            if (Object.keys(response.data.data).length > 0) {
              Axios.getMasters('farms/farms/only').then((response1) => {
                this.model.type = response.data.data.type;
                this.model.farm_id = response.data.data.farm_id;
                this.model.lot_id = response.data.data.lot_id;

                if (typeof this.model.farm_id !== 'undefined') {
                  Axios.getMasters('lots/' + this.model.farm_id).then(
                    (response2) => {
                      this.farms = response1.data.data;
                      this.lots = response2.data.data;

                      if (
                        this.model.farm_id != null &&
                        this.model.type != null
                      ) {
                        this.disabled = true;
                      }

                      if (this.model.type == 'Lote') {
                        this.disabledFarm = true;
                      }

                      this.showHideLoading();
                    }
                  );
                } else {
                  this.showHideLoading();
                }
              });
            } else {
              this.model.type = null;
              this.model.farm_id = null;
              this.model.lot_id = null;
              SweetAlert.warning(
                i18n.t('sweet_alert.fertilization.budgedted_card_null')
              );
            }
          })
          .catch((error) => this.showMessageErrors(error));
      }
    },
  },

  mounted() {
    this.showHideLoading(true);

    let editForm = {};

    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));

      this.model.id = editForm.id;
      this.model.date = moment(editForm.date).format('Y-M-D');
      this.model.hectares = editForm.hectares;
      this.model.type = editForm.type;
      this.model.farm_id = editForm.farm_id;
      this.model.lot_id = editForm.lot_id;

      this.getFarm();
      this.getLots();
      this.disabled = true;
      this.showHideLoading();
    }
  },
};
</script>
